

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IpServiceCategoryReportApi } from '../api/ip-service-category-report.api';
import { IpServiceCategoryReportData, IpServiceCategoryReport } from '../../../interfaces/report/ip-service-category-report';

@Injectable()
export class IpServiceCategoryReportService extends IpServiceCategoryReportData {

  constructor(private api: IpServiceCategoryReportApi) {
    super();
  }



  list(url: string): Observable<IpServiceCategoryReport[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<IpServiceCategoryReport>{
      return this.api.getById(url);
  }

  create(url: string, data:IpServiceCategoryReport): Observable<IpServiceCategoryReport> {
    return this.api.add(url,data);
  }

  update(url: string, data:IpServiceCategoryReport): Observable<IpServiceCategoryReport> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  searchList(url: string,data:any): Observable<any> { 
   
    return this.api.searchList(url,data);
  }
}
